export const TEAM_HEADERS = ['Name'];

export const TEAMS_PER_PAGE = 12;
